import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { ErrorPageComponent } from '../error-page/error-page.component';

@Component({
  selector: 'app-error404',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, ErrorPageComponent],
  host: { class: 'block h-full w-full' },
  templateUrl: './error404.component.html',
})
export class Error404Component {}
